var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105 1219 c-40 -12 -58 -28 -84 -69 -21 -34 -21 -43 -21 -509 0 -462 1 -474 21 -511 11 -20 35 -45 52 -56 30 -18 58 -19 567 -19 509 0 537 1 567 19 17 11 41 36 52 56 20 37 21 49 21 510 0 461 -1 473 -21 510 -11 20 -35 45 -52 56 -30 18 -60 19 -552 21 -302 1 -533 -2 -550 -8z m1070 -94 c16 -15 25 -36 25 -55 l0 -30 -560 0 -560 0 0 30 c0 19 9 40 25 55 l24 25 511 0 511 0 24 -25z m25 -555 l0 -391 -25 -24 -24 -25 -511 0 -511 0 -24 25 -25 24 0 391 0 390 560 0 560 0 0 -390z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 786 c-19 -22 -10 -126 12 -140 25 -16 51 4 55 43 l3 31 75 0 74 0 0 -184 0 -183 -29 -6 c-34 -7 -49 -40 -30 -63 9 -11 32 -14 103 -12 l91 3 3 28 c3 24 -2 30 -27 40 l-31 11 0 183 0 183 70 0 c67 0 70 -1 70 -24 0 -43 42 -70 68 -44 16 16 16 120 0 136 -19 19 -491 17 -507 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812 788 c-6 -6 -12 -20 -12 -29 0 -34 24 -40 165 -37 119 3 139 5 149 21 8 12 8 22 0 35 -10 15 -31 17 -150 20 -100 2 -143 -1 -152 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816 574 c-19 -19 -20 -36 -4 -52 17 -17 279 -17 296 0 16 16 15 33 -4 52 -23 23 -265 23 -288 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812 358 c-18 -18 -14 -46 7 -58 26 -13 256 -13 282 0 21 12 25 40 7 58 -17 17 -279 17 -296 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/title.628e4b57996741237c2da9f1347b9c0a.svg";
export { ForwardRef as ReactComponent };